import {
    SET_LOADING,
    SET_LOADED,
} from "../../actions/types";

const initialState = {
  token: localStorage.getItem("token"),
  loading: true,
  settings: {},
};



function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };
    case SET_LOADED:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}

export default reducer;
